<template>
    <nav>
        <div class="container">
            <h1 class="logo">GYMPO</h1>
            <ul>
                <a href="#hero-link" class="hero-link-link"></a>
                <a href="#classes" class="classes-link"><li>classes</li></a>
                <a href="#prices" class="prices-link"><li>prices</li></a>
                <a href="#trans" class="transformations-link"><li>BE/AF</li></a>
            </ul>
            <a href="" class="more">
                <img src="../assets/imgs/menu.svg" alt="">
            </a>
        </div>
    </nav>
    <div class="nav-space" style="height: 97px;"></div>
</template>